'use client';

import Link from 'next/link';
import Button from '../ui/Button';
import YouTubeFacade from '../ui/YouTubeFacade';

const VIDEO_EMBED =
  'https://www.youtube.com/embed/YOUR_VIDEO_ID?rel=0&modestbranding=1&showinfo=0';

/**
 * No poster yet.
 *
 * It used to be a stock product shot borrowed from a homepage banner, which
 * made a section that is not finished look like it was: the embed above still
 * points at YOUR_VIDEO_ID. Empty means the facade draws the stand-in.
 */
const POSTER_SRC = '';

export default function LookInsideDankSection() {
  return (
    <section aria-labelledby="look-inside-dank-heading">
      <div className="grid grid-cols-1 items-center gap-6 lg:grid-cols-2 lg:gap-12">
        <div className="flex max-w-xl flex-col max-sm:order-2 lg:max-w-none">
          <h2
            id="look-inside-dank-heading"
            className="mb-2 text-h2-mobile font-bold leading-tight text-text-primary sm:mb-6 sm:text-h2-desktop"
          >
            A Look Inside Dank
          </h2>
          <p className="text-body-14-mobile font-medium leading-relaxed text-text-secondary sm:text-body-md">
            Take a look inside Dank. From busy pop-ups to chill education nights, get a feel for the community and
            energy that keep our stores buzzing in Calgary. Hit play.
          </p>
          <div className="mt-8">
            <Button asChild variant="primary" size="lg" className="w-full sm:w-auto rounded-xl">
              <Link href="/about-us">
                Read more
              </Link>
            </Button>
          </div>
        </div>

        <div className="relative w-full max-sm:order-1 aspect-[644/375] max-sm:aspect-square">
          <div className="relative h-full w-full overflow-hidden rounded-2xl border border-neutral-10 bg-constant-white p-2 shadow-[0_8px_40px_rgba(23,22,90,0.12)]">
            <div className="relative h-full w-full overflow-hidden rounded-xl bg-neutral-5">
              <YouTubeFacade
                src={VIDEO_EMBED}
                title="A look inside Dank Cannabis"
                poster={POSTER_SRC}
                posterAlt=""
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
